import { AvrlBidCalc, BidRates } from "src/types/bid-rates";
import { LaneData } from "src/types/rate-data";
import { Card } from "src/components/card";
import { BreakdownButton } from "./breakdown";
import { ValueDisplay } from "src/components/value-display";
import { FeedbackButton } from "./feedback";
import { formatCurrency } from "src/types/number";
import { MapButton } from "./map-view";

export function RateRibbon({
    laneData,
    currentBidRates,
    calcDetails,
    loading,
}: {
    laneData: LaneData | null;
    currentBidRates: BidRates | null;
    calcDetails: AvrlBidCalc | null;
    loading: boolean;
}) {
    // In the event of a local move, disregard historical data and use constant values to populate ribbon.
    const isLocalMove = laneData?.originDat == laneData?.destinationDat;
    const greatValue = isLocalMove ? 800 : currentBidRates?.HighBid;
    const avgValue = isLocalMove ? 700 : currentBidRates?.AvgBid;
    const lowValue = isLocalMove ? 600 : currentBidRates?.LowBid;

    return (
        <div className="flex gap-3 flex-wrap">
            <Card customization="bg-[#baddb4] border-[#447f3a] text-[#447f3a] min-w-3xs">
                <ValueDisplay
                    title="All in Great Rate"
                    value={loading ? undefined : formatCurrency(greatValue)}
                />
            </Card>

            <Card customization="bg-[#dddcb4] border-[#7f7d3a] text-[#7f7d3a] min-w-3xs">
                <ValueDisplay
                    title="All in Avg Rate"
                    value={loading ? undefined : formatCurrency(avgValue)}
                />
            </Card>

            <Card customization="bg-[#ddb9b4] border-[#7f423a] text-[#7f423a] min-w-3xs">
                <ValueDisplay
                    title="All in Low Rate"
                    value={loading ? undefined : formatCurrency(lowValue)}
                />
            </Card>

            {loading ? (
                <div className="flex gap-2 items-end flex-wrap">
                    <div className="btn btn-xs skeleton w-30" />
                    <div className="btn btn-xs skeleton w-30" />
                    <div className="btn btn-xs skeleton w-30" />
                </div>
            ) : (
                <div className="flex gap-2 items-end flex-wrap">
                    <FeedbackButton bidRates={currentBidRates} />
                    <BreakdownButton
                        laneData={laneData}
                        // currentBidRates={currentBidRates}
                        calcDetails={calcDetails}
                    />
                    <MapButton />
                </div>
            )}
        </div>
    );
}
